import styled from "styled-components";
import { Link } from "gatsby";
import React from "react";

const BlogPostThumbnailStyles = {
    Container: styled.div`
        width: 100%;
    `,

    TextBoxOutline: styled.div`
        position: relative;
        top: -2px;
        /* z-index: -1; */
        background-color: black;
        width: 100%;
        height: 280px;
        display: flex;
        flex-flow: column;
        clip-path: polygon(
            100% 0%,
            100% calc(100% - 60px),
            calc(100% - 60px) 100%,
            0 100%,
            0 0
        );
        background: linear-gradient(
            90deg,
            rgba(0, 0, 0, 1) 50%,
            rgba(255, 233, 25, 1) 90%
        );
    `,

    TextBox: styled.div`
        background-color: white;
        width: 100%;
        /* height: max-content; */
        height: 100%;
        display: flex;
        flex-flow: column;
        justify-content: flex-start;
        align-items: center;
        clip-path: polygon(
            calc(100% - 2px) 2px,
            calc(100% - 2px) calc(100% - 61px),
            calc(100% - 61px) calc(100% - 2px),
            2px calc(100% - 2px),
            2px 2px
        );
        /* clip-path: polygon(
            99.7% 0.4%,
            99.7% 79.9%,
            89.9% 99.7%,
            0.2% 99.7%,
            0.2% 0.4%
        ); */
    `,

    InsideTextContainer: styled.div`
        width: 80%;
        height: 75%;
        display: flex;
        flex-flow: column;
        align-items: flex-start;
        justify-content: flex-start;
        /* border: 2px solid black; */
        margin: 40px 0px;
    `,

    CategoriesText: styled.div`
        font-size: 1.2rem;
        color: gray;
        text-transform: uppercase;
        margin-bottom: 5px;
    `,

    TitleText: styled.div`
        font-size: 1.6rem;
        color: black;
        font-weight: bold;
        margin-bottom: 20px;
    `,

    DescText: styled.div`
        font-size: 1.3rem;
        text-align: justify;
        display: ${(props) => (props.lines === 0 ? "none" : "-webkit-box")};
        line-height: 25px;
        -webkit-line-clamp: ${(props) => props.lines};
        -webkit-box-orient: vertical;
        /* border: 2px solid black; */
        overflow: hidden;
    `,

    ReadMoreLink: styled((props) => <Link {...props} />)`
        font-size: 1.3rem;
        margin-top: 26px;
        text-decoration: none;
        color: black;
        &:hover {
            text-decoration: underline;
            text-underline-offset: 3px;
        }
    `,
};

export default BlogPostThumbnailStyles;
